import React from 'react';
import BestInteriors from './BestInteriors';
import './BestInteriors.css';


export default function InteriorsPage() {
    return (
        <React.Fragment>
           <BestInteriors />
        </React.Fragment>
    )
}
